import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './ETPOS/CommonStyles.css';
import AddSell from './ETPOS/AddSell';
import AddDraft from './ETPOS/AddDraft';
import AddQuotation from './ETPOS/AddQuotation';
import AllSell from './ETPOS/AllSell';

const Sell = ({ activeTab: propActiveTab }) => {
  const [activeTab, setActiveTab] = useState('view');
  const [activeViewTab, setActiveViewTab] = useState('all_sales');
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  // Synchronize state with prop changes and pathname
  useEffect(() => {
    // If the prop specifies a specific sub-tab, prioritize it
    if (propActiveTab && propActiveTab !== 'sell') {
      if (propActiveTab === 'pos_sales' || propActiveTab === 'all_sales') {
        setActiveTab('view');
        setActiveViewTab('all_sales');
      } else if (propActiveTab === 'list_pos') {
        setActiveTab('view');
        setActiveViewTab('list_pos');
      } else if (propActiveTab === 'sales_returns') {
        setActiveTab('view');
        setActiveViewTab('sales_returns');
      } else if (propActiveTab === 'shipment' || propActiveTab === 'shipments') {
        setActiveTab('view');
        setActiveViewTab('shipment');
      } else if (propActiveTab === 'discount') {
        setActiveTab('view');
        setActiveViewTab('discount');
      } else if (propActiveTab === 'list_quotation') {
        setActiveTab('view');
        setActiveViewTab('list_quotation');
      } else if (propActiveTab === 'list_draft') {
        setActiveTab('view');
        setActiveViewTab('list_draft');
      } else if (propActiveTab === 'sell/add' || propActiveTab === 'add_sale') {
        setActiveTab('add');
      } else if (propActiveTab === 'sell/add-draft' || propActiveTab === 'add_draft') {
        setActiveTab('add_draft');
      } else if (propActiveTab === 'sell/add-quotation' || propActiveTab === 'add_quotation') {
        setActiveTab('add_quotation');
      }
    } else {
      // Otherwise fall back to location.pathname parsing
      if (location.pathname === '/sell/add') {
        setActiveTab('add');
      } else if (location.pathname === '/sell/add-draft') {
        setActiveTab('add_draft');
      } else if (location.pathname === '/sell/add-quotation') {
        setActiveTab('add_quotation');
      } else if (location.pathname === '/sell/pos-list' || location.pathname === '/sell/pos') {
        setActiveTab('view');
        setActiveViewTab('list_pos');
      } else if (location.pathname === '/sell/quotations') {
        setActiveTab('view');
        setActiveViewTab('list_quotation');
      } else if (location.pathname === '/sell/drafts') {
        setActiveTab('view');
        setActiveViewTab('list_draft');
      } else {
        setActiveTab('view');
        setActiveViewTab('all_sales');
      }
    }
  }, [propActiveTab, location.pathname]);

  // Render content based on active tab
  const renderContent = () => {
    if (activeTab === 'add') {
      return <AddSell />;
    } else if (activeTab === 'add_draft') {
      return <AddDraft />;
    } else if (activeTab === 'add_quotation') {
      return <AddQuotation />;
    } else {
      return <AllSell searchTerm={searchTerm} initialTab={activeViewTab} />;
    }
  };

  return (
    <div className="module-container">
      <div className="module-content1">
        {renderContent()}
      </div>
    </div>
  );
};

export default Sell;
